import { useState } from 'react';
import {
    useDeleteMemberDocumentMutation,
    useGetMemberDocumentsMutation,
    usePostMemberDocumentMutation
} from '@services/member/member/member.endpoints';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CdnFile } from '@services/core/cdn/file/file';

export const useDetailsDocumentsVM = () => {
    const { id } = useParams();
    const [documents, setDocuments] = useState<CdnFile[]>([]);

    const [
        getMember,
        {
            isLoading: isGetMemberDocumentsLoading,
            isUninitialized: isGetMemberDocumentsUninitialized,
            isError: isGetMemberDocumentsError,
            isSuccess: isGetMemberDocumentsSuccess,
            error: getMemberDocumentsError,
            data: getMemberDocumentsResponse
        }
    ] = useGetMemberDocumentsMutation();

    const [deleteMemberDocument] = useDeleteMemberDocumentMutation();
    const [postMemberDocument] = usePostMemberDocumentMutation();

    const handleDeleteDocument = async (documentId: string) => {
        await deleteMemberDocument({ id: id as string, documentId });
    };

    const handlePostDocument = async (file: CdnFile) => {
        await postMemberDocument({ id: id as string, file });
    };

    useEffect(() => {
        if (!id) return;
        getMember({ id });
    }, [id]);

    useEffect(() => {
        if (isGetMemberDocumentsLoading) return;
        if (isGetMemberDocumentsError) return;
        if (getMemberDocumentsError) return;

        if (isGetMemberDocumentsSuccess && getMemberDocumentsResponse) {
            setDocuments(getMemberDocumentsResponse.data);
        }
    }, [
        isGetMemberDocumentsError,
        isGetMemberDocumentsSuccess,
        getMemberDocumentsError,
        getMemberDocumentsResponse,
        isGetMemberDocumentsLoading
    ]);

    return {
        isLoading: isGetMemberDocumentsUninitialized || isGetMemberDocumentsLoading,
        isError: isGetMemberDocumentsError,
        documents,
        handleDeleteDocument,
        handlePostDocument
    };
};
